import { render } from "./ManufacturingBenefits.vue?vue&type=template&id=54c3bdc6&scoped=true"
import script from "./ManufacturingBenefits.vue?vue&type=script&lang=js"
export * from "./ManufacturingBenefits.vue?vue&type=script&lang=js"

import "./ManufacturingBenefits.vue?vue&type=style&index=0&id=54c3bdc6&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c3bdc6"]])

export default __exports__